import { Link } from "gatsby"

/** @jsx jsx */
import { jsx } from 'theme-ui'

const Logo = (props) => {
    const { 
        logo 
    } = props

    return (
        <h2
            sx={{
                fontSize: 2,
                textTransform: 'uppercase',
                letterSpacing: '2px',
                m: '0',
                color: 'text',
                px: 3, py: 2,
                bg: 'background',
                display: 'inline-block',
                // border: theme => `3px solid ${theme.colors.grey}`,
            }}
        >
            <Link to='/' sx={{
                textDecoration: 'none', 
                color: 'inherit',
                cursor: 'pointer',
            }}>
                <span sx={{
                    fontWeight: 'bold',
                    mr: 1,
                }}>
                    {logo[0]}
                </span>
                <span sx={{
                    fontWeight: 'body',
                    ml: 1,
                }}>
                    {logo[1]}
                </span>
                <span sx={{
                    ml: 1,
                    color: 'grey',
                }}>
                    .ch
                </span>
            </Link>
        </h2>
    )
}

export default Logo